export const TabKeys = {
  welcome: 'welcome',
  topics: 'topics',
  sidekicks: 'sidekicks',
  factFields: 'factFields',
  terminology: 'terminology',
  smeManagement: 'smeManagement',
  appUsers: 'appUsers',
  publishCM: 'publishCM',
  createCM: 'createCM',
  downloadApp: 'downloadApp',
  draftWelcomeMessage: 'draftWelcomeMessage',
  customerReps: 'customerReps',
} as const

export const stepToTabMap = {
  1: TabKeys.topics,
  2: TabKeys.sidekicks,
  3: TabKeys.factFields,
  4: TabKeys.smeManagement,
  5: TabKeys.terminology,
  6: TabKeys.downloadApp,
  7: TabKeys.createCM,
  8: TabKeys.publishCM,
  9: TabKeys.appUsers,
  10: TabKeys.draftWelcomeMessage,
  11: TabKeys.customerReps,
} as const

export type TabKey = (typeof TabKeys)[keyof typeof TabKeys]
